var map = {
	"./404.svg": "sEM+",
	"./baseDic.svg": "gbYJ",
	"./btn.svg": "O+kw",
	"./bug.svg": "SVqS",
	"./cache.svg": "sCmb",
	"./captcha.svg": "KpXy",
	"./catalog.svg": "SZh0",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./code.svg": "IX5Q",
	"./company.svg": "znPN",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./dic.svg": "mPW8",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./email.svg": "+4G4",
	"./enable.svg": "wMzE",
	"./excel.svg": "OLl3",
	"./eye.svg": "4wdf",
	"./file.svg": "fQ0v",
	"./form.svg": "sTIr",
	"./hot.svg": "j1mB",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./isElective.svg": "UDYY",
	"./language.svg": "+Dip",
	"./lock.svg": "FnAU",
	"./logout.svg": "KvOj",
	"./menu.svg": "dH9r",
	"./menu1.svg": "a9eS",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./new.svg": "1DKM",
	"./online.svg": "lWBX",
	"./other.svg": "/B26",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./recommend.svg": "rtce",
	"./role.svg": "cqqK",
	"./salesman.svg": "XNp0",
	"./screenful.svg": "omCx",
	"./setup.svg": "BJ8Q",
	"./setup1.svg": "/AQg",
	"./shoppingCard.svg": "dNDk",
	"./star.svg": "60zo",
	"./sysManage.svg": "xs3F",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./top.svg": "jE4f",
	"./updatePwd.svg": "Pidx",
	"./user.svg": "VdD3",
	"./user1.svg": "Ebwp",
	"./user2.svg": "AxbE",
	"./userLog.svg": "siXo",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 2